export const siteSettings = {
  name: "Arculus Trade",
  link: "https://arculustrade.com",
  email: "support@arculustrade.com",
  appLink: "https://app.arculustrade.com",
};
